// validations/changePassword.ts (o donde tengas tus schemas)
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

export const useChangePasswordValidationSchema = () => {
  const { t } = useTranslation();
  return Yup.object({
    oldPassword: Yup.string().required(t('pages.register.passwordRequired')),
    password: Yup.string()
      .min(8, t('pages.register.passwordMin'))
      .max(20, t('pages.register.passwordMax'))
      .matches(/[a-z]/, t('pages.register.passwordLowercase'))
      .matches(/[A-Z]/, t('pages.register.passwordUppercase'))
      .matches(/[0-9]/, t('pages.register.passwordNumber'))
      .matches(/[\W_]/, t('pages.register.passwordSpecial'))
      .notOneOf(
        ['password', '12345678', 'abc123'],
        t('pages.register.passwordNotCommon')
      )
      .test(
        'different-from-old',
        t('my_profile.passwordDifferentFromOld') ||
          'New password must be different',
        function (value) {
          const { oldPassword } = this.parent as { oldPassword: string };
          return !value || value !== oldPassword;
        }
      )
      .required(t('pages.register.passwordRequired')),

    confirmPassword: Yup.string()
      .required(t('pages.resetPassword.confirmPasswordRequired'))
      .oneOf(
        [Yup.ref('password'), null],
        t('pages.resetPassword.confirmPasswordMatch')
      ),
  });
};
